import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { EmspUserInvoiceBaseModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/emsp-user-invoice-base.model';
import { CellContext } from '@tanstack/react-table';

export interface EmspBoInvoiceListEmspUserLastNameCellProps
  extends CellContext<
    EmspUserInvoiceBaseModel,
    EmspUserInvoiceBaseModel['emspUser']['lastName']
  > {}

export const EmspBoInvoiceListEmspUserLastNameCell = (
  props: EmspBoInvoiceListEmspUserLastNameCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return <Text truncate>{getValue() ?? '-'}</Text>;
};
